import { createFileRoute, useNavigate } from "@tanstack/react-router";
import * as z from "zod";

import { useActorAppContactByAppUserIdQuery } from "~/graphql/graphql.gen";

// TEMPORARY ROUTE FOR MIGRATION
const contactRedirectQueryParamsSchema = z.object({
  userKey: z.string(),
});

export const Route = createFileRoute("/_auth/contact-redirect")({
  component: RouteComponent,
  validateSearch: (search) => contactRedirectQueryParamsSchema.parse(search),
});

function RouteComponent() {
  const navigate = useNavigate();
  const search = Route.useSearch();
  const { data: contact, isLoading } = useActorAppContactByAppUserIdQuery(
    {
      appUserId: search.userKey,
    },
    {
      select: (data) => data.supportActorAppContactByAppUserId,
    },
  );

  if (!isLoading && contact) {
    void navigate({
      to: "/contact/$contactId",
      params: {
        contactId: contact.id,
      },
    });
  }
  return <div>Redirecting...</div>;
}
